module.exports = __webpack_public_path__ + "b48ec43aacdb019745719ae98c048059.woff";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/graviton_-_agudabold-webfont.woff
// module id = 57
// module chunks = 28